import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const EMBED_ORIGIN = process.env.REACT_APP_EMBED_ORIGIN;

if (!API_BASE_URL) {
  throw new Error(
    "Missing REACT_APP_API_BASE_URL. Please set it in frontend/.env"
  );
}

const LS_TOKEN = "authToken";
const LS_USER = "authUser";
const LS_EMAIL = "userEmail";

const COMMON_CONFIG = {
  timeout: 12000,
};

export const clearAuthStorage = () => {
  localStorage.removeItem(LS_TOKEN);
  localStorage.removeItem(LS_USER);
  localStorage.removeItem(LS_EMAIL);

  localStorage.removeItem("accessToken");
  localStorage.removeItem("token");

  localStorage.removeItem("currentSpaceId");
  localStorage.removeItem("currentSpaceSlug");
  localStorage.removeItem("currentSpaceOwnerEmail");
  localStorage.removeItem("currentSpaceName");
};

const getToken = () =>
  localStorage.getItem(LS_TOKEN) ||
  localStorage.getItem("accessToken") ||
  localStorage.getItem("token") ||
  "";

const attachToken = (config) => {
  const token = getToken();

  if (!config.headers) {
    config.headers = {};
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

const isPublicOrAuthApi = (url = "") => {
  return (
    url.includes("/api/auth/login") ||
    url.includes("/api/auth/signup") ||
    url.includes("/api/auth/reset-password") ||
    url.includes("/api/auth/verify-email") ||
    url.includes("/api/auth/resend-verification") ||
    url.includes("/api/spaces/slug/") ||
    url.includes("/api/walloflove/embed/") ||
    url.includes("/api/testimonials/public") ||
    url.includes("/api/testimonials/submit") ||
    url.includes("/api/testimonials/text/public") ||
    url.includes("/api/testimonials/video/public")
  );
};

const handleAuthError = (error) => {
  const status = error?.response?.status;
  const requestUrl = error?.config?.url || "";

  if ((status === 401 || status === 403) && !isPublicOrAuthApi(requestUrl)) {
    clearAuthStorage();

    window.dispatchEvent(
      new CustomEvent("auth:session-expired", {
        detail: { status },
      })
    );
  }

  return Promise.reject(error);
};

const createApiClient = ({ attachAuth = true } = {}) => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    ...COMMON_CONFIG,
  });

  if (attachAuth) {
    instance.interceptors.request.use(attachToken);
  }

  instance.interceptors.response.use((response) => response, handleAuthError);

  return instance;
};

const apiBase = createApiClient({ attachAuth: true });
const auth_api = createApiClient({ attachAuth: true });
const user_api = createApiClient({ attachAuth: true });
const subscription_api = createApiClient({ attachAuth: true });

const public_api = createApiClient({ attachAuth: false });

export default {
  apiBase,
  auth_api,
  user_api,
  subscription_api,
  public_api,
};
